import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import express from '@/const/express';
import { downloadFile } from '@/utils/downloadFile';
var expressList = express.map(function (v) {
  return {
    label: v.company,
    value: v.code
  };
});
export default {
  meta: {
    title: '提现详情',
    auth: true,
    authorityValue: 'store-transfers-manage'
  },
  name: 'walletDetail',
  data: function data() {
    return {
      expressList: expressList,
      dataObj: {},
      // 表格数据
      tableData: [],
      openInfoData: {
        invoiceType: 1,
        invoiceCode: '',
        invoiceNumber: '',
        priceTaxSubtotal: '',
        taxRate: '',
        excludingTaxAmount: '',
        invoiceImage: '',
        expressNo: '',
        expressCompany: '',
        invoiceDate: ''
      },
      rules: {
        invoiceImage: [{
          required: true,
          message: '请上传发票',
          trigger: 'blur'
        }]
      },
      totalIncome: 0,
      totalPay: 0,
      totalOpen: 0
    };
  },
  methods: {
    showTransferStatus: function showTransferStatus(row, e) {
      if (Array.isArray(e)) {
        return e.includes(row.transferStatus);
      } else {
        return row.transferStatus == e;
      }
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.openInfoData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['openInfoData'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      // if (!YL.beforeUploadCommon(file, 'pic')) return false
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.transferDetails(item);

              case 2:
                data = _context.sent;
                _this.dataObj = data;

                _this.dataObj.billList.forEach(function (e) {
                  _this.totalIncome += e.cashbackAmount + e.commissionAmount;
                  _this.totalPay += e.goodsAmount;
                });

                _this.totalOpen = _this.totalPay - _this.totalIncome;
                _this.openInfoData = Object.assign(_this.openInfoData, _this.dataObj);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubim: function onSubim() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$refs['openInfoData'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 5;
                              break;
                            }

                            _context2.next = 3;
                            return _this2.$api.saveInvoice(_objectSpread(_objectSpread({}, _this2.openInfoData), _this2.$route.query));

                          case 3:
                            YL.message('提交成功');

                            _this2.goBack();

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleInput: function handleInput(e) {
      var num = this.openInfoData.priceTaxSubtotal / (1 + +e);
      this.openInfoData.excludingTaxAmount = num.toFixed(2);
    },
    toDownloadFile: function toDownloadFile(a, b) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return downloadFile(a, b);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  filters: {
    expressCompany: function expressCompany(code) {
      var name = '';
      express.forEach(function (e) {
        if (e.code === code) {
          name = e.company;
        }
      });
      return name;
    }
  },
  created: function created() {
    var query = this.$route.query;
    this.dataBind(query);
    this.getQiNiu();
  }
};